import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit"]
  static values = { required: { type: String, default: "confirm" } }

  check() {
    if (this.inputTarget.value.trim().toLowerCase() === this.requiredValue.toLowerCase()) {
      this.submitTarget.disabled = false
    } else {
      this.submitTarget.disabled = true
    }
  }
}
